module.exports = {"key":"hello russian","submit":"Отправить отзыв!","hide":"Скрыть это","skip":"Пропустить и перейти к следующему вопросу","placeholder":"Пожалуйста, опишите ваши эмоции по этому поводу..."}


//////////////////
// WEBPACK FOOTER
// ./src/translations/ru.json
// module id = 449
// module chunks = 0